import React from "react";
import styles from "./Footer.module.css";
import logo from "../../assets/images/logo.jpg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className={styles.wrapper} id="footer">
      <div className={styles.footerParentContainer}>
        <div className={styles.firstContainer}>
          <img src={logo} alt=""></img>
          <p>
            Cricway is a mobile application that provides live cricket scores
            and line rates for cricket matches in India. With a user-friendly
            interface and up-to-the-minute updates, Cricway allows users to stay
            on top of the latest scores and stats for all major cricket
            tournaments and matches.
          </p>
        </div>
        <div className={styles.secondContainer}>
          <h4>Quick Links</h4>
          <ul className={styles.appNavbarLinks}>
            <li className={styles.navLinks}>
              <Link to={"/"}>Home</Link>
            </li>
            <li className={styles.navLinks}>
              <Link to={"/"}>About</Link>
            </li>
            <li className={styles.navLinks}>
              <Link to={"/privacy-policy"}>Privacy & Policy</Link>
            </li>
            <li className={styles.navLinks}>
              <Link to={"/terms-conditions"}>Terms & Conditions</Link>
            </li>
            <li className={styles.navLinks}>
              <Link to={"contact-us"}>Contact Us</Link>
            </li>
          </ul>
        </div>
        <div class={styles.thirdContainer}>
          <h2 class={styles.getInTouchHeading} id="getInTouch">
            Get In Touch
          </h2>

          <div id="mobile" className={styles.contact}>
            <i class="fa-solid fa-phone"></i> +91 9560910427
          </div>
          <div id="email" className={styles.contact}>
            <i class="fa-solid fa-envelope"></i> info@cricway.live
          </div>
          <div id="address" className={styles.contact}>
            <i class="fa-solid fa-location-dot"></i> A-84, Sector 4, <br/> Gautam
            Buddha Nagar Noida,<br/> Uttar pradesh 201301 India
          </div>
        </div>
      </div>
      <p className={styles.allRightReserved}>
        © 2024
        , Cricway.live. All rights reserved.{" "}
      </p>
    </div>
  );
};

export default Footer;
